import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
interface WPFileProgress {
  id: string | number;
  progress: string;
}
@Injectable()
export class ImageReadyService {
  ready: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  progress: BehaviorSubject<WPFileProgress[]> = new BehaviorSubject<WPFileProgress[]>([]);
  private _progress: WPFileProgress[] = [];
  done() {
    this.ready.next(true);
  }

  updateProgress(num: string, id: string | number = 0) {
    let found = this._progress.filter((item: WPFileProgress) => item.id === id);
    if (found.length) {
      found.forEach((item: WPFileProgress) => item.progress = num);
    } else {
      this._progress.push({id, progress: num});
    }
    this.progress.next(this._progress);
  }

  wait() {
    this.ready.next(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/providers/image.ready.service.ts